export enum FederationType {
  None = 'NONE',
  FederatedSelf = 'FEDERATED_SELF',
  FederatedInheritDescendants = 'FEDERATED_INHERIT_DESCENDANTS',
  StandardInheritDescendants = 'STANDARD_INHERIT_DESCENDANTS',
}
